import { useEffect, useState } from 'react';
import { sendEvent, useEventNotification } from '../../features/visual-analytics/hooks/events';
import { ModalPortal } from '../modal-portal/ModalPortal';

import styles from './MessageBoxes.module.scss';

const MSGCountDownBox = 'ShowCountDownBox';

export interface TpCountDownData {
  title: string;
  description: string;
  timer: number;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
}

interface TpCountDownModalData {
  countDownData: TpCountDownData;
  callBackOK: any;
  callBackCancel: any;
}

export function promptCountDownBox(countDownData: TpCountDownData) {
  return new Promise((resolve, reject) => {
    function callBackOK() {
      resolve(true);
    }

    function callBackCancel() {
      reject();
    }

    const confirmModalData: TpCountDownModalData = {
      countDownData,
      callBackOK,
      callBackCancel,
    };
    sendEvent(MSGCountDownBox, confirmModalData);
  });
}

export function CountDownBox() {
  const [activeBox, setActiveBox] = useState<TpCountDownModalData | null>(null);
  const [countDown, setCountDown] = useState<number | null>(null);

  useEffect(() => {
    if (countDown === 0) {
      activeBox?.callBackCancel();
      setActiveBox(null);
      setCountDown(null);
    } else if (countDown) {
      const timer = setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [countDown]);

  useEventNotification(
    MSGCountDownBox,
    (tpe: string, contentInput: TpCountDownModalData) => {
      setActiveBox(contentInput);
      setCountDown(contentInput.countDownData.timer);
    },
    [],
  );

  if (!activeBox) return null;
  if (!countDown) return null;

  return (
    <ModalPortal close={() => {}}>
      <div className={styles.confirmMessageBox}>
        <div className={styles.title}>{activeBox.countDownData.title}</div>
        {activeBox.countDownData.description}
        <div className={styles.buttonSection}>
          <button
            onClick={() => {
              activeBox.callBackCancel();
              setActiveBox(null);
              setCountDown(null);
            }}
          >
            {activeBox.countDownData.cancelButtonLabel ? activeBox.countDownData.cancelButtonLabel : 'Cancel'}
          </button>
          <button
            onClick={() => {
              activeBox.callBackOK();
              setActiveBox(null);
              setCountDown(null);
            }}
          >
            {activeBox.countDownData.okButtonLabel ? activeBox.countDownData.okButtonLabel : 'Confirm'} ({countDown})
          </button>
        </div>
      </div>
    </ModalPortal>
  );
}
